module.exports = __webpack_public_path__ + "static/img/3_13_1.4b725446.jpg";